/* unplugin-vue-components disabled */import { render } from "./UserAgreements.vue?vue&type=template&id=f96138b4&scoped=true"
import script from "./UserAgreements.vue?vue&type=script&lang=js"
export * from "./UserAgreements.vue?vue&type=script&lang=js"

import "./UserAgreements.vue?vue&type=style&index=0&id=f96138b4&lang=scss&scoped=true"

import exportComponent from "/Users/rabbuse/Project/Vue/quan-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f96138b4"]])

export default __exports__